import { withAuth } from 'hoc/withAuth'
import Home from 'components/pages/Home'

export default withAuth(Home)
